import { render, staticRenderFns } from "./showList.vue?vue&type=template&id=201edd7e&scoped=true"
import script from "./showList.vue?vue&type=script&lang=js"
export * from "./showList.vue?vue&type=script&lang=js"
import style0 from "./showList.vue?vue&type=style&index=0&id=201edd7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201edd7e",
  null
  
)

export default component.exports